module.exports = __webpack_public_path__ + "assets/img/4346-cd.svg";